export const LIBERATION_TYPES = {
  BY_DAYS: 'BY_DAYS',
  BY_DATE: 'BY_DATE',
  EXPIRATION: 'EXPIRATION',
  REMOVE_DRIPPING: 'REMOVE_DRIPPING'
};

const normalizeDrippingData = (drippingData) => {
  if (
    !drippingData.liberationType ||
    drippingData.liberationType === LIBERATION_TYPES.BY_DAYS
  ) {
    drippingData.liberationDate = null;
  }

  if (
    !drippingData.liberationType ||
    drippingData.liberationType === LIBERATION_TYPES.BY_DATE
  ) {
    drippingData.liberationDays = null;
  }

  if (!drippingData.hasDuration) {
    drippingData.durationDays = null;
  }

  return drippingData;
};

const normalizeDrippingDataFromMask = (drippingData) => {
  const {
    hasDuration = false,
    liberationDate = null,
    liberationType = null
  } = drippingData;

  Object.assign(drippingData, { hasDuration, liberationDate, liberationType });

  if (
    !drippingData.liberationDays &&
    parseInt(drippingData.liberationDays) !== 0
  ) {
    drippingData.liberationDays = null;
  } else {
    drippingData.liberationDays = parseInt(drippingData.liberationDays);
  }

  if (!drippingData.durationDays && parseInt(drippingData.durationDays) !== 0) {
    drippingData.durationDays = null;
  } else {
    drippingData.durationDays = parseInt(drippingData.durationDays);
  }

  return drippingData;
};

export { normalizeDrippingData, normalizeDrippingDataFromMask };
